<template>
  <v-dialog :value="open" :width="600" persistent scrollable>
    <v-card>
      <v-card-title class="title">Member ID: {{ value ? value.member_id : '-' }}</v-card-title>
      <v-card-text>
        <MemberEditForm
          :key="key"
          :value="value"
          :loading="loading"
          @cancel="$emit('update:open', false)"
          @submit="handleSubmit"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import juzmatchApi from '@/api/juzmatch'
import MemberEditForm from './MemberEditForm.vue'

export default {
  components: {
    MemberEditForm
  },
  model: {
    prop: 'open',
    event: 'update:open'
  },
  props: {
    value: {
      type: Object,
      default: undefined
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      key: Date.now(),
      loading: false
    }
  },
  watch: {
    open(value) {
      if (value) {
        this.key = Date.now()
      }
    }
  },
  methods: {
    async handleSubmit(value) {
      try {
        this.loading = true

        await juzmatchApi.updateMember({
          user_id: this.value.id,
          page_id: this.value.page_id,
          full_name: value.name,
          identity_card_no: value.phone,
          project: value.project,
          member_type: value.type
        })

        this.$emit('submitted', {
          ...this.value,
          full_name: value.name,
          identity_card_no: value.phone,
          project: value.project,
          member_type: value.type
        })
        this.$emit('update:open', false)
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/Juzmatch/MemberEditDialog.vue